<template>
  <div :class="{'cursor-pointer':item.deleted_at == null}" @dblclick="changeStatus()">
    <b-badge v-if="statusState" variant="success">
      منتشر شده
    </b-badge>
    <b-badge v-else variant="danger">منتشر نشده</b-badge>
  </div>
</template>

<script>
import axios from "axios";

export default {
  props: {
    item: {
      default: null
    },
    itemType: {
      default: null
    }
  },
  name: "StatusChanger",
  computed: {
    statusState() {
      if (this.item && this.item.status == 1) {
        return true;
      } else {
        return false;
      }
    },
  },
  methods: {
    changeStatus() {
      if (this.item.deleted_at == null) {
        const status = !this.item.status ? 1 : 0


        const form = {
          item_type: this.itemType,
          status: status,
          item_id: this.item.id
        }

        this.$store.dispatch('Content/changeStatus', form)
            .then((res) => {
              this.item.status = status
            })
            .catch((error) => {
              console.log(error);
            });
      }

    }
  }
}
</script>

<style scoped>
.cursor-pointer {
  cursor: pointer;
}
</style>